import { Card, Checkbox, PageLayout } from '@kcftech/design-system';
import { NumberInput } from 'components/forms/NumberInput';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const StyledTable = styled.table`
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;

    th, td {
        padding: 1rem;
        padding-left: 1.5rem;
        text-align: left;
        color: ${tokens.text.secondary};
    }

    tbody tr:first-child td {
        border-top: 1px solid ${tokens.border.default};
    }

    tbody td {
        border-bottom: 1px solid ${tokens.border.default};
        color: ${tokens.text.primary};
    }
`;

export const StyledCard = styled(Card)`
    padding: 1.5rem;
    border-radius: 1rem;
`;

export const StyledWarningCard = styled(StyledCard)`
    color: ${tokens.alert.warningColor};
`;

export const IconRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
`;

export const HoverSpan = styled.span`
    cursor: pointer;
`;

export const WarningSpan = styled.span`
    color: ${tokens.alert.warningColor};
`;

export const HoverRef = styled(HoverSpan)`
    text-decoration: underline;
`;

export const StyledCheckbox = styled(Checkbox)`
    width: 1.7rem;
    height: 1.7rem;
`;

export const StyledNumberInput = styled(NumberInput)`
    border: 1px solid ${tokens.input.border};
    border-width: 1.5px !important;
    padding-bottom: ${tokens.input.padding} !important;
    padding-left: 0.5rem;
    border-radius: 3px;
    background-color: ${tokens.input.background};
    width: 15rem;
`;

export const StyledBoundsInput = styled(NumberInput)<{
    $selected?: boolean;
}>`
    border-radius: 3px;
    background-color: ${tokens.input.background};
    width: 22rem;
    height: 3rem;
    border: ${({ $selected }) => ($selected ? `1.5px solid ${tokens.input.border}` : 'none')};
    color: ${({ $selected }) => ($selected ? `${tokens.text.primary}` : `${tokens.text.secondary}`)};
    padding-left: 0.5rem;
`;

export const FlushPrimary = styled(PageLayout.Primary)`
    margin-right: 0;
`;

export const StyledSecondary = styled(PageLayout.Secondary)`
    min-width: 28rem;
    max-width: 28rem;
    max-height: 100%;
    overflow: auto;
`;

export const PrimaryText = styled.span`
    color: ${tokens.text.primary};
    font-weight: normal;
`;

export const SecondaryText = styled.span`
    color: ${tokens.text.secondary};
`;

export const NotificationCriteriaWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 0.8rem;

    > :first-child,
    > :last-child {
        flex: 1;
        min-width: 0;
    }
`;

export const PercentageInput = styled(StyledNumberInput)`
    width: 13rem;
`;

// Not the prettiest method but works to align "of" with input fields.
export const OfContainer = styled.div`
    padding-top: 2.7rem;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
`;

export const AlarmAndNotificationWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;
    width: 100%;
    > :first-child,
    > :last-child {
        flex: 1;
        min-width: 0;
    }
`;

export const StyledLink = styled(NavLink)`
    text-decoration: none;
    color: ${tokens.text.link};
`;
